import { render, staticRenderFns } from "./GridItem.vue?vue&type=template&id=aaff0e7a&scoped=true"
import script from "./GridItem.vue?vue&type=script&lang=js"
export * from "./GridItem.vue?vue&type=script&lang=js"
import style0 from "./GridItem.vue?vue&type=style&index=0&id=aaff0e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaff0e7a",
  null
  
)

export default component.exports